import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/admin.api';
import { LoadingSpinner } from '../components/common/LoadingSpinner';

interface RequireRoleProps {
  roles: string[];
}

export const RequireRole: React.FC<RequireRoleProps> = ({ roles }) => {
  const location = useLocation();
  const { data, isLoading } = useQuery({
    queryKey: ['admin-profile'],
    queryFn: () => adminApi.profile(),
  });

  if (isLoading) {
    return <LoadingSpinner message="Checking permissions..." />;
  }

  const user = data?.data;
  if (!user || !roles.includes(user.role)) {
    return <Navigate to="/games" replace state={{ from: location }} />;
  }

  return <Outlet />;
};